import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '@/components/feature/BrandLogo';
import { navLinks } from '@/mocks/strategix';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-xl border-b border-background-200/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-5 md:px-10 h-[72px] flex items-center justify-between gap-6">
        <BrandLogo href="/" />

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            aria-label="Открыть меню"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-950 cursor-pointer"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-100 border-t border-background-200/70 px-5 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMenuOpen(false)}
              className="px-2 py-3 text-sm text-foreground-700 hover:text-foreground-950 border-b border-background-200/50 last:border-b-0 transition-colors cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}